import XmarkBold from './XmarkBold';

export default XmarkBold;
